export default __webpack_public_path__ + "static/media/success.1976bf97.svg";